import { createAction, props } from '@ngrx/store';
import { CartData } from '../../core/service/cart-apis/interfaces/get-cart.interface';

export const setCart = createAction(
  '[Cart] Set Cart',
  props<{ CartData: CartData }>()
);

export const resetCart = createAction(
  '[Cart] Reset Cart'
);
